import React, { useState } from "react";

interface AssetPreviewProps {
  pictureFile: File;
  audioFile: File;
}

export const AssetPreview: React.FC<AssetPreviewProps> = ({
  pictureFile,
  audioFile,
}) => {
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [audioSrc, setAudioSrc] = useState<string | null>(null);

  // Generate previews for the files
  React.useEffect(() => {
    if (pictureFile) {
      const imageUrl = URL.createObjectURL(pictureFile);
      setImagePreview(imageUrl);
      return () => URL.revokeObjectURL(imageUrl);
    }
  }, [pictureFile]);

  React.useEffect(() => {
    if (audioFile) {
      const audioUrl = URL.createObjectURL(audioFile);
      setAudioSrc(audioUrl);
      return () => URL.revokeObjectURL(audioUrl);
    }
  }, [audioFile]);

  return (
    <>
      {audioSrc && (
        <div className="pt-2 pb-2">
          <audio
            controls={true}
            controlsList="nodownload"
            src={audioSrc}
            className="w-full"
          >
            <source src={audioSrc} type={audioFile.type} />
            Your browser does not support the audio tag.
          </audio>
        </div>
      )}
      <div className="flex justify-between items-center gap-4 flex-col">
        {imagePreview && (
          <div
            style={{
              backgroundImage: `url(${imagePreview})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
            className="w-48 h-48"
          />
        )}
      </div>
    </>
  );
};
